export default {
  computed: {
    isBackend () {
      return this.$route.path.includes('/backend-tech-support')
    },
  },
  created () {
    const actions = []
    actions.push({
      label: this.$t('scope.pay'),
      action: (row) => {
        this.$router.push({
          path: '/account/checkout',
          query: {
            payment_id: row.id,
          },
        })
      },
      meta: (obj) => {
        return {
          validate: obj.status === 'init' || obj.status === 'requesting',
        }
      },
      hidden: (obj) => this.isBackend,
    })
    actions.push({
      label: this.$t('billing.payment.apply_withdraw'),
      action: (row) => {
        const amount = Number(row.amount) || 0
        this.$confirm({
          title: this.$t('billing.payment.withdraw_title'),
          content: this.$t('billing.payment.withdraw_confirm', [amount.toFixed(2)]),
          okText: this.$t('billing.payment.withdraw_ok'),
          cancelText: this.$t('dialog.cancel'),
          onOk: async () => {
            const paymentM = new this.$Manager('billing_payments')
            try {
              await paymentM.performAction({
                id: row.id,
                action: 'refund',
                data: {
                  amount,
                  reason: this.$t('billing.payment.withdraw_reason'),
                },
              })
              this.$message.success(this.$t('billing.payment.withdraw_success'))
              this.refresh()
            } catch (error) {
              this.$message.error(error.response?.data?.message || this.$t('billing.payment.withdraw_failed'))
            }
          },
        })
      },
      meta: (obj) => {
        return {
          validate: obj.status === 'complete' || obj.status === 'refund_failed',
        }
      },
      hidden: (obj) => this.isBackend,
    })
    actions.push({
      label: this.$t('dialog.cancel'),
      action: (row) => {
        this.$confirm({
          title: this.$t('scope.billing.cancel_confirm'),
          content: this.$t('billing.payment.cancel_confirm') + row.description,
          onOk: async () => {
            const paymentM = new this.$Manager('billing_payments')
            try {
              await paymentM.performAction({
                id: row.id,
                action: 'cancel',
              })
              this.$message.success(this.$t('billing.payment.cancel_success'))
              this.refresh()
            } catch (error) {
              this.$message.error(error.response?.data?.message || this.$t('billing.payment.cancel_failed'))
            }
          },
        })
      },
      meta: (obj) => {
        return {
          validate: obj.status === 'init' || obj.status === 'requesting',
        }
      },
    })
    this.singleActions = actions
  },
}
